export default __webpack_public_path__ + "static/media/SG-Red-0000.b07da121.png";